import {push} from 'connected-react-router/immutable';
import {i18n} from '../services/i18n';
import {createError} from '../services/errors';
import {local} from '../services/local';
import {HOME} from '../services/routes';
import {nextStep, prevStep} from './fluxes';
import {getUserCompany} from '../reducers/user';
import {
  getCurrentCompanyId,
  getCompanyById,
  getCompaniesSelection
} from '../reducers/companies';
import {createRepo} from '../services/repo';
const companiesRepo = createRepo({
  modelName: 'company',
  plural: 'companies',
  isGlobal: true,
  getCurrentCompanyId,
  validateNewItemData({name}) {
    if (!name) {
      return i18n._(
        'companies.no_valid_company',
        {},
        {defaults: 'No valid company name'}
      );
    }

    return null;
  },
  buildNewItemData({name, companyId}) {
    return {
      name,
      companyId
    };
  }
});

export const {
  companiesLoadingSuccess,
  loadCompaniesFromRepo,
  loadCompanyFromRepo
} = companiesRepo.actionCreators;

export const NO_CURRENT_COMPANY_ERROR = 'NO_CURRENT_COMPANY_ERROR';

export const noCurrentCompanyError = createError(NO_CURRENT_COMPANY_ERROR);

export function loadCompanies() {
  return loadCompaniesFromRepo;
}

export function loadCompany(id, redirect = true) {
  return function(dispatch, getState) {
    loadCompanyFromRepo(id, dispatch, getState).catch(error => {
      if (error && redirect) {
        dispatch(push(NOT_FOUND));
      }
    });
  };
}
